export class ErrorDto {
  private pErrorMessage: string | null = '';

  get errorMessage(): string | null {
    return this.pErrorMessage;
  }

  set errorMessage(value: string | null) {
    this.pErrorMessage = value;
  }

  private pAuthCode: string | null = null;

  get authCode(): string | null {
    return this.pAuthCode;
  }

  set authCode(value: string | null) {
    this.pAuthCode = value;
  }

  private pCode: number | null = null;

  get code(): number | null {
    return this.pCode;
  }

  set code(value: number | null) {
    this.pCode = value;
  }

  private pPath = '';

  get path(): string {
    return this.pPath;
  }

  set path(value: string) {
    this.pPath = value;
  }

}
